'use client';

import { useTranslations } from 'next-intl';
import { AlertTriangleIcon, RefreshCcwIcon } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export default function ErrorMessage({
  error,
}: {
  error: Error & {
    digest?: string;
  };
}) {
  const t = useTranslations('errors');

  return (
    <div className="container flex min-h-[calc(100vh-4rem)] items-center justify-center">
      <div className="mx-auto max-w-md space-y-4 text-center">
        <div className="flex max-w-[90vw] flex-col items-center space-y-2">
          <h1 className="flex items-center gap-2 font-semibold text-2xl tracking-tight">
            <AlertTriangleIcon className="h-6 w-6 text-destructive" />
            {t('global-error-title')}
          </h1>
          <p className="text-muted-foreground text-sm">{t('global-error-description')}</p>
        </div>

        <div className="space-y-2">
          <Alert className="border-0" variant="destructive">
            <AlertTitle className="hidden" />
            <AlertDescription className="space-y-2">
              <div>{process.env.NODE_ENV === 'development' ? error.message : t('genericError')}</div>

              {error.digest && <div className="hidden">{error.digest}</div>}
            </AlertDescription>
          </Alert>
        </div>

        <Button onClick={() => window.location.reload()} variant="outline">
          <RefreshCcwIcon className="mr-2 h-4 w-4" />
          {t('global-error-button')}
        </Button>
      </div>
    </div>
  );
}
